import * as React from 'react';
export const cicSvg = React.forwardRef(function cicSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0095AB',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17 32h15V0H15v17h2v15Z',
      fill: '#004FA2',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27 19.27v1.38a6.81 6.81 0 0 1-2.14.35c-2.96 0-5.36-2.22-5.36-4.71 0-2.49 2.36-4.29 5.36-4.29a6.542 6.542 0 0 1 2.15.36v1.44a6.851 6.851 0 0 0-2.25-.9c-2.32 0-3.11 1.65-3.11 3.39 0 1.74.79 3.81 3.11 3.81a6.26 6.26 0 0 0 2.24-.83Zm-15 0v1.38a6.81 6.81 0 0 1-2.14.35C6.9 21 4.5 18.78 4.5 16.29 4.5 13.8 6.86 12 9.86 12a6.542 6.542 0 0 1 2.15.36v1.44a6.851 6.851 0 0 0-2.25-.9c-2.32 0-3.11 1.65-3.11 3.39 0 1.74.79 3.81 3.11 3.81a6.26 6.26 0 0 0 2.24-.83Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 12h2v9h-2v-9Z',
      fill: '#F05A30',
    }),
  );
});
cicSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var cic = {
  category: 'brand',
  colorable: false,
  name: 'cic',
  svg: cicSvg,
};
